import {z} from 'zod';

export const ReceiveNoteBasicInformationFormSchema = z.object({
  supplierId: z.string(),
  warehouseId: z.string(),
  authorizationProfileId: z.string(),
  number: z.string().nullish(),
  date: z.date().nullish(),
  invoiceNumber: z.string().nullish(),
  invoiceIssueDate: z.date().nullish(),
  paymentType: z.string(),
  currency: z.string(),
  exchangeRate: z.number().nullish(),
  ncConversion: z.string().nullish(),
  deliveryNoteNumber: z.string().nullish(),
  deliveryNoteIssueDate: z.date().nullish(),
  note: z.string().nullish(),
});

export type ReceiveNoteBasicInformationForm = z.infer<typeof ReceiveNoteBasicInformationFormSchema>;
